const REMEMBERED_EMAIL_KEY = 'remembered-email'
const REMEMBER_ME_EXPIRY_DAYS = 30

export function getRememberedEmail(): string | null {
  try {
    const stored = localStorage.getItem(REMEMBERED_EMAIL_KEY)
    if (!stored) return null

    const parsed = JSON.parse(stored)

    if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY)
      return null
    }

    return parsed.email || null
  } catch {
    localStorage.removeItem(REMEMBERED_EMAIL_KEY)
    return null
  }
}

export function setRememberedEmail(email: string | null): void {
  try {
    if (email) {
      const expiresAt =
        Date.now() + REMEMBER_ME_EXPIRY_DAYS * 24 * 60 * 60 * 1000
      localStorage.setItem(
        REMEMBERED_EMAIL_KEY,
        JSON.stringify({ email, expiresAt })
      )
    } else {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY)
    }
  } catch {
    // Ignore storage errors
  }
}
